import { Pipe, PipeTransform } from "@angular/core";
import { ProductRequestStatus } from "../enums/product-request-status";
import { getProductRequestStatusColor } from "../helpers/get-product-request-status-color";

@Pipe({name: 'getProductRequestStatusColor'})
export class GetProductRequestStatusColorPipe implements PipeTransform {
  transform(value: ProductRequestStatus): string {
    return getProductRequestStatusColor(value);
  }
}